import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GetUserAccessTokenResponse, ValidateUserTokenResponse } from '../models/query-interface';

@Injectable({
  providedIn: 'root',
})
export class FacebookService {
  FACEBOOK_BASE_URL = 'https://graph.facebook.com';
  constructor(private http: HttpClient) {}

  getUserAccessToken(appId: string, appSecret: string): Observable<GetUserAccessTokenResponse> {
    const url = `${this.FACEBOOK_BASE_URL}/oauth/access_token?client_id=${appId}&client_secret=${appSecret}&grant_type=client_credentials`;
    return this.http.get<GetUserAccessTokenResponse>(url);
  }

  validateUserToken(userAccessToken: string, appAccessToken: string): Observable<ValidateUserTokenResponse> {
    const url = `${this.FACEBOOK_BASE_URL}/debug_token?input_token=${appAccessToken}&access_token=${userAccessToken}`;
    return this.http.get<ValidateUserTokenResponse>(url);
  }
}
